import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const BookingError = () => {
    const location = useLocation();
    const technicalMessage = location.state?.message;

    useEffect(() => {
        if (technicalMessage) {
            console.error("Booking Error:", technicalMessage);
        }
    }, [technicalMessage]);

    return (
        <div className="min-h-screen flex flex-col items-center justify-center bg-[#FFF5F5] text-[#831515] px-4 text-center">
            <h2 className="text-3xl font-bold mb-4">😓 Booking Unavailable</h2>
            <p className="text-lg max-w-xl mb-6">
                We're sorry, but the booking system is temporarily unavailable.
                Your request could not be processed at this time.
            </p>
            <p className="text-md text-gray-700 mb-8">
                Please try again later, or contact us directly:
            </p>
            <div className="text-md space-y-2 text-gray-800">
                <p>📞 Phone: <a href="tel:+27 (0) 16 940 4444" className="text-blue-700 underline">+27 (0) 16 940 4444</a></p>
                <p>📧 Email: <a href="bookings@beneckegroup.com" className="text-blue-700 underline">bookings@beneckegroup.com</a></p>
                <p>💬 WhatsApp: <a href="https://wa.me/1234567890" className="text-blue-700 underline" target="_blank" rel="noopener noreferrer">Chat with us</a></p>
            </div>
            <a
                href="/"
                className="mt-10 inline-block px-6 py-3 bg-[#F29E38] text-[#023059] font-semibold rounded-full hover:bg-opacity-90 transition"
            >
                Return Home
            </a>
        </div>
    );
};

export default BookingError;
